function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-20 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-31 {\n        fill: #414042;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 16.18,
  cy: 11.25,
  fx: 16.18,
  fy: 11.25,
  r: 7.33,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fef7e2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#fdf2d3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#fce5a6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#fbda81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#fad164"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#facb4f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#fac843"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fac73f"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 951.44,
  fx: 951.44,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 918.04,
  fx: 918.04,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 884.64,
  fx: 884.64,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: 851.23,
  fx: 851.23,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-6",
  cx: 817.83,
  fx: 817.83,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-7",
  cx: 784.43,
  fx: 784.43,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-8",
  cx: 751.03,
  fx: 751.03,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-9",
  cx: 717.62,
  fx: 717.62,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-10",
  cx: 684.22,
  fx: 684.22,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-11",
  cx: 650.82,
  fx: 650.82,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-12",
  cx: 617.42,
  fx: 617.42,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-13",
  cx: 584.02,
  fx: 584.02,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-14",
  cx: 550.61,
  fx: 550.61,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-15",
  cx: 517.21,
  fx: 517.21,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-16",
  cx: 483.81,
  fx: 483.81,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-17",
  cx: 450.41,
  fx: 450.41,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-18",
  cx: 417,
  fx: 417,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-19",
  cx: 383.6,
  fx: 383.6,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-20",
  cx: 350.2,
  fx: 350.2,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-21",
  cx: 316.8,
  fx: 316.8,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-22",
  cx: 283.39,
  fx: 283.39,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-23",
  cx: 249.99,
  fx: 249.99,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-24",
  cx: 216.59,
  fx: 216.59,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-25",
  cx: 183.19,
  fx: 183.19,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-26",
  cx: 149.79,
  fx: 149.79,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-27",
  cx: 116.38,
  fx: 116.38,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-28",
  cx: 82.98,
  fx: 82.98,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-29",
  cx: 49.58,
  fx: 49.58,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-30",
  cx: 984.84,
  fx: 984.84,
  r: 7.33,
  xlinkHref: "#radial-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "page_content",
  "data-name": "page content"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-31",
  width: 1000,
  height: 22.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "cls-16",
  cx: 16.18,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-22",
  cx: 951.44,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-23",
  cx: 918.04,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 884.64,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 851.23,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-13",
  cx: 817.83,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 784.43,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 751.03,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 717.62,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 684.22,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-28",
  cx: 650.82,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-15",
  cx: 617.42,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-18",
  cx: 584.02,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 550.61,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-21",
  cx: 517.21,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 483.81,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-24",
  cx: 450.41,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 417,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 383.6,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 350.2,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 316.8,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 283.39,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-27",
  cx: 249.99,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-20",
  cx: 216.59,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 183.19,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 149.79,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 116.38,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 82.98,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-26",
  cx: 49.58,
  cy: 11.25,
  r: 7.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-19",
  cx: 984.84,
  cy: 11.25,
  r: 7.33
}))));

function SvgMarqueeLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarqueeLights);
export default __webpack_public_path__ + "static/media/marquee-lights.146052b9a9ef941ff16f3ff121f5a82f.svg";
export { ForwardRef as ReactComponent };